export default __webpack_public_path__ + "static/media/Blank-dark.6f30b09d.svg";